export * from './documController.service';
import { DocumControllerService } from './documController.service';
export * from './documentoInteresController.service';
import { DocumentoInteresControllerService } from './documentoInteresController.service';
export * from './plantillaDocumController.service';
import { PlantillaDocumControllerService } from './plantillaDocumController.service';
export * from './plantillaEmailController.service';
import { PlantillaEmailControllerService } from './plantillaEmailController.service';
export const APIS = [DocumControllerService, DocumentoInteresControllerService, PlantillaDocumControllerService, PlantillaEmailControllerService];
